@if (form) {
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12 col-sm-8">
                <div class="row">
                    @if (pushpinPart.material_id !== 5) {
                        <mat-form-field appearance="fill" class="col-sm-7 col-12">
                            <mat-label>
                                <span class="ucfirst">
                                    {{pushpinPart.decoration.decoration_group}}
                                </span>
                                @if (pushpinPart.decoration.decoration_group == 'Lengtemarkering' && !pushpin.lengthmark) {
                                    <span> (kort)</span>
                                }
                            </mat-label>
                            <mat-select
                                (selectionChange)="decorationChange($event)"
                                formControlName="decoration_id"
                                id="{{uniqueId}}decoration"
                                placeholder="Figuratie">
                                @for (decoration of decorations; track decoration) {
                                    <mat-option
                                        [value]="decoration.id">
                                        {{decoration.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                    @if (AuthorisationService.hasFeature('customerAreaWithWork') && (pushpinPart.status_id === 3 || pushpinPart.status_id === 4) && executionAllowed) {
                        <div class="col-12 col-sm-5">
                            <mat-checkbox
                                (change)="realizedCheckboxChange($event)"
                                [checked]="realizedCheckbox"
                                class="mt-3 d-block"
                                id="realized"
                                name="blast">
                                Gerealiseerd
                            </mat-checkbox>
                        </div>
                    }
                    @if (AuthorisationService.hasFeature('statusGiveOrder') && (pushpinPart.status_id === 2 || pushpinPart.status_id === 3) && pushpinPart.inspection.inspection_status.selection_allowed) {
                        <div class="col-12 col-sm-5">
                            <mat-checkbox
                                (change)="freeForExecutionCheckboxChange($event)"
                                [checked]="freeForExecution"
                                class="mt-3 d-block"
                                id="freeForExecution"
                                name="freeForExecution">
                                Vrij voor uitvoering
                            </mat-checkbox>
                        </div>
                    }
                    @if (AuthorisationService.hasFeature('pushpinPartStatusChangeAsNotVVRuserAllowd') && initialStatus !== undefined && initialStatus !== null) {
                        <mat-form-field appearance="fill" class="col-sm-5 col-12">
                            <mat-label>Status</mat-label>
                            <mat-select
                                (selectionChange)="statusChange($event)"
                                formControlName="status_id"
                                id="{{uniqueId}}status"
                                placeholder="Status">
                                @for (status of statusList; track status) {
                                    <mat-option
                                        [class.bold]="initialStatus.id === status.id"
                                        [disabled]="statusDisabled(status)"
                                        [value]="status.id">
                                        {{status.name}}
                                    </mat-option>
                                }
                            </mat-select>
                            @if (dateExecuted) {
                                <mat-hint>
                                    Uitgevoerd op {{dateExecuted | date  : 'd MMM yyyy, H:mm'}}
                                </mat-hint>
                            }
                        </mat-form-field>
                    }
                </div>
                <div class="row">
                    @if (pushpinPart.decoration.type != 'Diversen vervangen') {
                        <mat-form-field appearance="fill" class="col-md-5 col-sm-6 col-5">
                            <mat-label>CROW</mat-label>
                            <mat-select formControlName="crow" id="{{uniqueId}}crow" placeholder="A+ - D">
                                <mat-option value="A+">A+</mat-option>
                                <mat-option value="A">A</mat-option>
                                <mat-option value="B">B</mat-option>
                                <mat-option value="C">C</mat-option>
                                <mat-option value="D">D</mat-option>
                            </mat-select>
                            <mat-error>Selecteer een waarde</mat-error>
                            <button (click)="crowDialog($event)" aria-label="Clear" mat-icon-button matSuffix>
                                <mat-icon class="fas fa-question"></mat-icon>
                            </button>
                        </mat-form-field>
                    }
                    <mat-form-field appearance="fill" class="col-md-7 col-sm-6 col-7">
                        <mat-label>Materiaal</mat-label>
                        <mat-select
                            (selectionChange)="materialChange($event)"
                            formControlName="material_id"
                            id="{{uniqueId}}material"
                            placeholder="Materiaal">
                            @for (material of materials; track material) {
                                <mat-option [disabled]="material.id === 5" [value]="material.id">
                                    {{material.name}}
                                </mat-option>
                            }
                        </mat-select>
                        <mat-error>Selecteer een materiaal</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    @if (pushpinPart.material.color) {
                        <mat-form-field appearance="fill" class="col-sm-4">
                            <mat-label>Kleur</mat-label>
                            <mat-select formControlName="paint_color_id" id="{{uniqueId}}paintcolor" placeholder="Verf kleur">
                                @for (paintColor of paintColors(); track paintColor) {
                                    <mat-option [value]="paintColor.id">
                                        {{paintColor.name}}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-error>Selecteer een kleur</mat-error>
                        </mat-form-field>
                    }
                    @if (pushpinPart.decoration.specify_length) {
                        <mat-form-field appearance="fill" class="col-8">
                            <mat-label>Lengte</mat-label>
                            <input
                                class="inpLength"
                                formControlName="length"
                                id="{{uniqueId}}length"
                                matInput
                                placeholder="Lengte in meters" step="0.01"
                                type="number">
                            @if (pushpin.lengthmark) {
                                <div class="d-flex" matSuffix>
                                    <button (click)="multiplyLength(2)" color="accent" mat-icon-button>
                                        2 X
                                    </button>
                                    <button (click)="multiplyLength(3)" color="accent" mat-icon-button>
                                        3 X
                                    </button>
                                    <button (click)="multiplyLength(4)" color="accent" mat-icon-button>
                                        4 X
                                    </button>
                                    <button (click)="multiplyLength(null)" color="accent" mat-icon-button>
                                        <i class="fas fa-undo"></i>
                                    </button>
                                </div>
                            }
                            <mat-error>Vul een lengte in meters in</mat-error>
                            @if (pushpinPart.final_length && pushpinPart.final_length != pushpinPart.length) {
                                <mat-hint
                                    matSuffix>
                                    <span class="changed-val">{{pushpinPart.final_length | number:'1.0-2'}}</span>
                                </mat-hint>
                            }
                        </mat-form-field>
                    }
                    @if (!pushpinPart.decoration.specify_length && pushpinPart.decoration.surface !== null) {
                        <mat-form-field appearance="fill" class="col-md-5 col-6">
                            <mat-label>Aantal</mat-label>
                            <input formControlName="amount" id="{{uniqueId}}amount" matInput name="amount" placeholder="Aantal"
                                   type="number">
                            <mat-error>Dit veld mag niet kleiner zijn dan 1</mat-error>
                            @if (pushpinPart.final_amount && pushpinPart.final_amount != pushpinPart.amount) {
                                <mat-hint matSuffix>
                                    <span class="changed-val">{{pushpinPart.final_amount}}</span>
                                </mat-hint>
                            }
                        </mat-form-field>
                    }
                    @if (pushpinPart.decoration.surface === null &&
                    pushpinPart.decoration.type !== 'Diversen vervangen' &&
                    pushpinPart.decoration.decoration_group !== 'Voorgevormd' &&
                    pushpinPart.decoration.type) {
                        <mat-form-field appearance="fill" class="col-sm-6">
                            <mat-label>Oppervlakte</mat-label>
                            <input
                                class="inpSurface"
                                formControlName="surface"
                                id="{{uniqueId}}surface"
                                matInput
                                placeholder="Oppervlakte in m²"
                                step="0.01" type="number">
                            <mat-error>Vul een oppervlakte in m² in</mat-error>
                            @if (pushpinPart.final_surface && pushpinPart.final_surface != pushpinPart.surface) {
                                <mat-hint
                                    matSuffix>
                                    <span class="changed-val">{{pushpinPart.final_surface | number:'1.0-2'}}</span>
                                </mat-hint>
                            }
                        </mat-form-field>
                    }
                </div>
                @if (AuthorisationService.hasFeature('changePushpinPartInspection')) {
                    <div class="row">
                        @if (inspections) {
                            <mat-form-field
                                appearance="fill"
                                class="col-12">
                                <mat-label>{{inspection ? 'Schouwronde' : 'Selecteer een schouwronde'}}</mat-label>
                                <mat-select formControlName="inspection_id" id="{{uniqueId}}inspection_id" placeholder="Selecteer een schouwronde">
                                    @for (inspection of inspections; track inspection) {
                                        <mat-option [value]="inspection.id">
                                            {{inspection.name}}
                                        </mat-option>
                                    }
                                </mat-select>
                                <mat-error>Selecteer een schouwronde</mat-error>
                            </mat-form-field>
                        }
                    </div>
                }
            </div>
            <div class="col-sm-4 d-flex d-sm-block flex-wrap mt-3 mt-sm-0 mb-2 mb-sm-0">
                @if (primers?.length === 1) {
                    <mat-checkbox class="d-block inpPrimer me-3 mb-3 mb-sm-0" formControlName="primer" id="{{uniqueId}}primer" name="primer">
                        Primer
                    </mat-checkbox>
                }
                @if (primers?.length > 1) {
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Primer</mat-label>
                        <mat-select formControlName="primer" placeholder="Primer">
                            <mat-option [value]="null">
                                Geen
                            </mat-option>
                            @for (material of primers; track material) {
                                <mat-option [value]="material.id">
                                    {{material.name}}
                                </mat-option>
                            }
                        </mat-select>
                        <mat-error>Selecteer een materiaal</mat-error>
                    </mat-form-field>
                }
                <mat-checkbox
                    class="d-block inpBlast me-3 mb-3 mb-sm-0"
                    formControlName="blast"
                    id="{{uniqueId}}blast"
                    name="blast">
                    Stralen
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpStakeout me-3 mb-3 mb-sm-0"
                    formControlName="stake_out"
                    id="{{uniqueId}}stake_out"
                    name="stake_out">
                    Uitzetten
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpTrafficControllers me-3 mb-3 mb-sm-0"
                    formControlName="traffic_controllers"
                    id="{{uniqueId}}traffic_controllers"
                    name="traffic_controllers">
                    Verkeersregelaars
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpturbo_burn me-3 mb-3 mb-sm-0"
                    formControlName="turbo_burn"
                    id="{{uniqueId}}turbo_burn"
                    name="turbo_burn">
                    Turbo branden
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpmanual_burn me-3 mb-3 mb-sm-0"
                    formControlName="manual_burn"
                    id="{{uniqueId}}manual_burn"
                    name="manual_burn">
                    Handmatig branden
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpnight me-3"
                    formControlName="night"
                    id="{{uniqueId}}night"
                    name="night">
                    Nacht
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpnight me-3"
                    formControlName="exclusive_material"
                    id="{{uniqueId}}exclusive_material"
                    name="exclusive_material">
                    Exclusief materiaal
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpnight me-3"
                    formControlName="overgrown"
                    id="{{uniqueId}}overgrown"
                    name="overgrown">
                    Overgroeide kanten
                </mat-checkbox>
                <mat-checkbox
                    class="d-block inpnight me-3"
                    formControlName="clean_surface"
                    id="{{uniqueId}}clean_surface"
                    name="clean_surface">
                    Schoonmaken ondergrond
                </mat-checkbox>
            </div>
        </div>
        <div class="row">
            <mat-form-field appearance="fill" class="col-md-12">
                <mat-label>Opmerkingen</mat-label>
                <textarea
                    cdkAutosizeMinRows="4"
                    cdkTextareaAutosize
                    class="inpDescription"
                    formControlName="description"
                    id="{{uniqueId}}description"
                    matInput
                    name="description"
                    placeholder="Voeg hier eventuele notities en opmerkingen toe"
                    type="text">
                </textarea>
                <mat-error>{{pushpinPart.material_id === 5 ? 'Bij voorgevormde thermoplast is een opmerking verplicht' : 'Het opmerkingen veld mag niet langer dan 16500 tekens zijn'}}</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field appearance="fill" class="col-md-12">
                <mat-label>{{AuthorisationService.hasFeature('pushpinConsumerDescription') ? 'Opmerking' : 'Opmerking klant'}}</mat-label>
                <textarea
                    cdkAutosizeMinRows="4"
                    cdkTextareaAutosize
                    formControlName="customer_note"
                    id="customer_note"
                    matInput
                    name="customer_note"
                    placeholder="Voeg hier eventuele notities en opmerkingen toe"
                    type="text">
                </textarea>
                <mat-error>Dit veld mag maximaal 16500 tekens bevatten</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="images">
                    @for (image of pushpinPart.images; track image.id) {
                        <div class="image-wrapper">
                            <div class="image-aspect">
                                @if (image.drawn_image) {
                                    <div class="drawn">
                                        <i class="fa-solid fa-pen-swirl"></i>
                                    </div>
                                }
                                <div
                                    (click)="openImage(pushpinPart.images, image)"
                                    [style.background-image]="(image.drawn_image ?? image.image)|safeBgUrl"
                                    class="image curpoint">
                                    <div class="text">
                                        {{image.status.name}}<br>
                                        @if (image.updated_at) {
                                            {{image.updated_at | date : 'd MMM yyyy, H:mm'}}
                                        }
                                        @if (!image.updated_at) {
                                            Zojuist gemaakt
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    @if (!isCordova) {
                        <div [class.dragover]="uploadDrag" class="image-wrapper drag">
                            <div class="image-aspect">
                                <div class="image d-flex align-items-center">
                                    <i class="fas fa-image fa-8x"></i>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                @if (!isCordova && (!pushpinPart.images || pushpinPart.images.length < 1)) {
                    <small>
                        <i>
                            Upload afbeeldingen voor dit deel door ze hierheen te slepen.
                        </i>
                    </small>
                }
            </div>
        </div>
    </form>
}
